import { BetButton } from '@svs/ui/react/bet-button';
import type { ReactNode } from 'react';

import { type CouponIndex } from '../../schema/coupon/entry.js';

export type CouponOutcomeSrowBaseProps = {
  // outcome is optional since it could be over/under with no outcome for X outcome
  outcome?: string;
  index: number;
  isEmptyOutcome?: boolean;
  buttonSize?: React.ComponentProps<typeof BetButton>['size'];
  onTouchStart: () => void;
  onPointerDown: () => void;
  onPointerCancel: () => void;
  onTouchCancel: () => void;
};

export type CouponOutcomeSrowProps = CouponOutcomeSrowBaseProps & {
  eventNumber: number;
  isDisabled?: boolean;
  couponIndex?: CouponIndex;
  isSelected?: boolean;
};

/**
 * This component renders the correct structure for an outcome in a coupon. It handles if the outcome is disabled and if it is selected.
 *
 * @param root0 The couponoutcome input props
 * @param root0.eventNumber Number for event
 * @param root0.index Index for the outcome
 * @param root0.outcome Outcome to be displayed
 * @param root0.isDisabled Is the input field is disabled
 * @param root0.isEmptyOutcome Boolean for if the outcome is empty
 * @param root0.couponIndex Index of the coupon, used for multi coupon
 * @param root0.buttonSize Size of the ui button
 * @param root0.onTouchStart Handler for touch start event
 * @param root0.onPointerDown Handler for pointer down event
 * @param root0.onPointerCancel Handler for pointer cancel event
 * @param root0.onTouchCancel Handler for touch cancel event
 * @param root0.isSelected wether or not the outcome is selected
 * @returns Component to visually represent an outcome and select it if needed
 */
export default function CouponOutcomeSrow({
  eventNumber,
  index,
  outcome,
  isDisabled,
  isEmptyOutcome,
  couponIndex,
  buttonSize,
  onTouchStart,
  onPointerDown,
  onPointerCancel,
  onTouchCancel,
  isSelected,
}: CouponOutcomeSrowProps): ReactNode {
  return (
    <BetButton
      className={isSelected ? '' : 'text-primary-variant-fg border-primary-variant-fg border'}
      data-testid={`couponButton_${eventNumber}_${index}${couponIndex === undefined ? '' : `_${couponIndex}`}`}
      size={buttonSize}
      disabled={isDisabled ?? isEmptyOutcome}
      value={outcome?.toString() ?? ''}
      onPointerDown={onPointerDown}
      onTouchStart={onTouchStart}
      onPointerCancel={onPointerCancel}
      onTouchCancel={onTouchCancel}
    >
      {outcome}
    </BetButton>
  );
}
